import styled from 'styled-components';

const imageWidth = 844 / 3;
const imageHeight = 770 / 3;

export const StyledAbout = styled.div`
  .intro {
    font-style: italic;
    font-weight: bold;
    margin: 20px 0 40px;
    font-size: var(--font-size-h3);
  }
  .people {
    margin: 80px 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 60px 20px;

    .person {
      display: flex;
      flex-direction: column;
      align-items: center;

      .person-image {
        width: ${imageWidth}px;
        height: ${imageHeight}px;
      }

      .person-info {
        margin-top: 15px;
        text-align: center;
        display: flex;
        flex-direction: column;

        .person-name {
          margin: 0;
        }

        .person-role {
          font-weight: 300;
        }
      }

      .person-description {
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
  }
`;
